import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {multiLineTruncate} from '@travel-frontend/ui-components';

export const Headline = styled.div(
  ({theme}) => css`
    color: ${theme.colors.contentInversePrimary};
    font: 700 1.375rem / 1.75rem 'Open Sans';
    display: -webkit-box;
    ${multiLineTruncate(1)};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `
);
